import { Injectable } from '@angular/core';
import { EligibilityCandidate } from '@kp/eligibility/eligibility-candidate.model';
import { WorkbookRequest } from '@kp/workbook/models/workbook-request.model';
import { WorkbookApi } from '@kp/workbook/workbook.api';
import { DataStatus, Status, StatusMessage } from '@ktypes/models';
import { DateTimeUtil } from '@kutil';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkbookBloc {
  constructor(private _workbookApi: WorkbookApi) {}

  private _workbookOrderStatus$ = new BehaviorSubject<DataStatus<WorkbookRequest>>(null);

  get workbookOrderStatus$(): Observable<DataStatus<WorkbookRequest>> {
    return this._workbookOrderStatus$.asObservable();
  }
  get workbookOrderStatus(): DataStatus<WorkbookRequest> {
    return this._workbookOrderStatus$.getValue();
  }

  private _workbookRequestStatus$ = new BehaviorSubject<DataStatus<string>>(null);

  get workbookRequestStatus$(): Observable<DataStatus<string>> {
    return this._workbookRequestStatus$.asObservable();
  }

  private _workbookCandidate$ = new BehaviorSubject<EligibilityCandidate>(null);

  get workbookCandidate$(): Observable<EligibilityCandidate> {
    return this._workbookCandidate$.asObservable();
  }

  updateCandidate(eligibilityCandidate: EligibilityCandidate) {
    this._workbookCandidate$.next(eligibilityCandidate);
  }

  declineWorkbook() {
    this._workbookOrderStatus$.next(
      new DataStatus<WorkbookRequest>(
        Status.done,
        null,
        new WorkbookRequest().deserialize({
          declined: true,
          requested: false,
        })
      )
    );
  }

  checkWorkbookOrder(): void {
    this._workbookOrderStatus$.next(
      new DataStatus<WorkbookRequest>(Status.starting, new StatusMessage(Status.starting, ''), null)
    );
    this._workbookApi.getWorkbookOrder().then((orderStatus) => {
      this._workbookOrderStatus$.next(orderStatus);
    });
  }

  createWorkbookRequest(eligibilityCandidate: EligibilityCandidate): void {
    this._workbookRequestStatus$.next(
      new DataStatus<string>(Status.starting, new StatusMessage(Status.starting, ''), null)
    );
    this._workbookApi.createWorkBookRequest(eligibilityCandidate).then((responseCandidate) => {
      if (responseCandidate.status === Status.done) {
        this._workbookOrderStatus$.next(
          new DataStatus<WorkbookRequest>(
            Status.done,
            null,
            new WorkbookRequest().deserialize({
              requested: true,
              dateOrdered: DateTimeUtil.formatInLocal(),
            })
          )
        );
      }
      this._workbookRequestStatus$.next(responseCandidate);
    });
  }
}
